module.exports = __webpack_public_path__ + "static/img/tab2.a38ffbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/championscity/challenge/tab2.png
// module id = 5/M7
// module chunks = 1